/// <reference path="_references.js" />

if (!isNullOrUndefined(sumo)) {
    throw ('SumoClass.js: Cannot create the sumo namespace. An object with this name already exists.');
}
/** @namespace */
var sumo = {}; // sumo namespace

/** 
 * Sumo Class 
 * This is one of the base classes used across the sumo framework.
 * used in: 
 * Hash.js, Cache.js, Geo.js, Layer.js, Locate.js, Playback.js, SumoControlFactory.js, Dashboard.js,
 * Sumo.js
 * @constructor
 * @memberof sumo 
 * @class Class
*/
/** @namespace */
sumo.Class = function () {
    "use strict";

    // this is required because the array prototype contains 'filter' function and this 
    // makes EventCallbacks return it's prototype for filter instead of the function we tried to bind
    var mEventNamePrefix = 'sumo.';
    /** EventCallbacks[] array contains the list of the Callbacks set using bind@fn  */
    this.EventCallbacks = {};
    /**
     * Return the name of a given function
     * e.g. function abc(){} 
     * result will be "abc"
     * @param  {function} aFunctionReference
     * @returns {string} string name
     */
    this.functionName = function (aFunctionReference) {
        return (/(\w+)\(/.exec(aFunctionReference.toString()))[1];
    };
    /**
     * Return the Class Name inside given child .constructor
     * @returns {string} the function name of this.constructor
     */
    this.className = function () {
        return this.functionName(this.constructor);
    };
    /**
     * Check if Object is empty, null or undefined
     * @param  {} aObject
     * @returns {boolean} true / false 
     */
    this.isNothing = function (aObject) {
        return (aObject === null || typeof aObject === 'undefined');
    };
    /**
     * This fn will create an event into the EventStack 'sumo.aEventName' bind
     * Add event to EventCallbacks[]
     * @param  {string} aEventName
     * @param  {requestCallback} aHandler
     * @param  {object} aData
     */
    this.bind = function (aEventName, aHandler, aData) {
        var lEventName = mEventNamePrefix + aEventName,
            lCallbacks = this.EventCallbacks[lEventName];
        if (aHandler === null) {
            throw ('Programmer error: Cannot bind a null handler to an event.');
        }
        if (this.isNothing(lCallbacks)) {
            lCallbacks = [];
            this.EventCallbacks[lEventName] = lCallbacks;
        }
        lCallbacks.push({ 'handler': aHandler, 'data': aData });
    };
    /**
     * This function will unbind an specific Event 'sumo.aEventName'
     * @param  {string} aEventName
     * @param  {requestCallback} aHandler
     */
    this.unbind = function (aEventName, aHandler) {
        var lIndex,
            lCallback = null,
            lEventName = mEventNamePrefix + aEventName,
            lCallbacks = this.EventCallbacks[lEventName];

        if (aHandler === null) {
            throw ('Programmer error: Cannot bind a null handler to an event.');
        }

        if (!this.isNothing(lCallbacks)) {
            for (lIndex = 0; lIndex < lCallbacks.length; lIndex++) {
                lCallback = lCallbacks[lIndex];
                if (lCallback.handler === aHandler) {
                    lCallbacks[lIndex] = null;
                    lCallbacks.splice(lIndex, 1);
                    break;
                }
            }   
        }
    };
    /**
     * Trigger an specific event with given parameters 
     * @param  {string} aEventName
     * @param  {object} aEventParameters
     */
    this.trigger = function (aEventName, aEventParameters) {
        var lIndex,
            lCallback = null,
            lEventName = mEventNamePrefix + aEventName,
            lCallbacks = this.EventCallbacks[lEventName],
            lHandlers = [];
        /**
         * This callback is displayed as part of the Requester class.
         * @callback Requester~requestCallback
         * @param {object} aEventParameters
         * @param {object} data
         */
        if (!this.isNothing(lCallbacks)) {
            for (lIndex = 0; lIndex < lCallbacks.length; lIndex++) {
                lCallback = lCallbacks[lIndex];
                if (!this.isNothing(lCallback.handler)) {
                    lHandlers.push(lCallback);
                }
            }
            for (lIndex = 0; lIndex < lHandlers.length; lIndex++) {
                lCallback = lHandlers[lIndex];
                lCallback.handler(this, aEventParameters, lCallback.data);
            }
        }
    };
    /**
     * Remove all callbacks, listeners from the EventCallback[] list
     */
    this.dispose = function () {
        var lKeyOuter = null,
            lKeyInner = null,
            lDeletedOuter = true,
            lDeletedInner = true,
            lCallback = null,
            lCallbacks = null,
            lListener = null;
        while (lDeletedOuter) {
            lDeletedOuter = false;
            for (lKeyOuter in this.EventCallbacks) {
                if (this.EventCallbacks.hasOwnProperty(lKeyOuter)) {
                    lCallbacks = this.EventCallbacks[lKeyOuter];
                    while (lDeletedInner) {
                        lDeletedInner = false;
                        for (lKeyInner = 0; lKeyInner < lCallbacks.length; lKeyInner++) {
                            if (!this.isNothing(lCallbacks[lKeyInner])) {
                                lCallbacks[lKeyInner] = null;
                                lCallbacks.splice(lKeyInner, 1);
                                lDeletedInner = true;
                                break;
                            }
                        }
                    }
                    this.EventCallbacks[lKeyOuter] = null;
                    delete this.EventCallbacks[lKeyOuter];
                    lDeletedOuter = true;
                    break;
                }
            }
        }
    };
};

if (typeof exports !== 'undefined') {
    module.exports = sumo.Class;
}